(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["elevia-app-detail"] && !Shopify.designMode) return;
  try {
    

document.querySelectorAll('[data-elevia-detail]').forEach(root => {
  const menu = root.querySelector('.ed-menu');
  menu?.querySelectorAll('a').forEach(link => link.addEventListener('click', () => { menu.open = false; }));
  menu?.addEventListener('keydown', event => { if (event.key === 'Escape') { menu.open = false; menu.querySelector('summary').focus(); } });
  document.addEventListener('click', event => { if (menu?.open && !menu.contains(event.target)) menu.open = false; });
  const links = [...root.querySelectorAll('.ed-header nav a[href^="#"]')];
  const watched = [...new Set(links.map(link => root.querySelector(link.getAttribute('href'))).filter(Boolean))];
  const highlight = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (!entry.isIntersecting) return;
      links.forEach(link => {
        const active = link.getAttribute('href') === '#' + entry.target.id;
        link.classList.toggle('is-current', active);
        if (active) link.setAttribute('aria-current', 'location'); else link.removeAttribute('aria-current');
      });
    });
  }, {rootMargin:'-90px 0px -60% 0px'});
  watched.forEach(section => highlight.observe(section));
const tabs=[...root.querySelectorAll('.ed-feature-tabs [role="tab"]')];
const panels=[...root.querySelectorAll('.ed-feature-panel')];
function selectFeature(tab,focus){tabs.forEach(item=>{const active=item===tab;item.setAttribute('aria-selected',String(active));item.tabIndex=active?0:-1});panels.forEach(panel=>{panel.hidden=panel.id!==tab.getAttribute('aria-controls');panel.classList.toggle('is-entering',!panel.hidden)});if(focus)tab.focus()}
tabs.forEach((tab,index)=>{tab.addEventListener('click',()=>selectFeature(tab,false));tab.addEventListener('keydown',event=>{let next;if(event.key==='ArrowRight')next=(index+1)%tabs.length;else if(event.key==='ArrowLeft')next=(index+tabs.length-1)%tabs.length;else if(event.key==='Home')next=0;else if(event.key==='End')next=tabs.length-1;else return;event.preventDefault();selectFeature(tabs[next],true)})});
let glasses=3;const waterCount=root.querySelector('[data-water-count]');const waterAdd=root.querySelector('[data-water-add]');function paintWater(){waterCount.textContent=glasses+' '+waterAdd.dataset.suffix;root.querySelectorAll('.ed-water-glasses span').forEach((item,index)=>item.classList.toggle('filled',index<glasses));waterAdd.disabled=glasses===8}waterAdd.addEventListener('click',()=>{glasses=Math.min(8,glasses+1);paintWater()});root.querySelector('[data-water-reset]').addEventListener('click',()=>{glasses=3;paintWater()});
const dialog=root.querySelector('.ed-image-dialog');const image=dialog.querySelector('img');const scroll=dialog.querySelector('.ed-image-scroll');const toggle=dialog.querySelector('[data-image-toggle]');let opener;let previousOverflow;
function openImage(button,src,alt){opener=button;image.src=src;image.alt=alt;scroll.classList.remove('is-zoomed');toggle.textContent=toggle.dataset.zoomIn;toggle.setAttribute('aria-pressed','false');previousOverflow=document.body.style.overflow;document.body.style.overflow='hidden';dialog.showModal()}
root.querySelectorAll('[data-zoom-source]').forEach(button=>button.addEventListener('click',()=>openImage(button,button.dataset.zoomSource,button.dataset.zoomAlt)));
root.querySelectorAll('[data-zoom-image]').forEach(button=>button.addEventListener('click',()=>{const img=button.querySelector('img');openImage(button,img.currentSrc||img.src,img.alt)}));
dialog.querySelector('[data-image-close]').addEventListener('click',()=>dialog.close());dialog.addEventListener('close',()=>{document.body.style.overflow=previousOverflow||'';opener?.focus()});toggle.addEventListener('click',()=>{const zoomed=scroll.classList.toggle('is-zoomed');toggle.setAttribute('aria-pressed',String(zoomed));toggle.textContent=zoomed?toggle.dataset.zoomOut:toggle.dataset.zoomIn});
const reduced=window.matchMedia('(prefers-reduced-motion: reduce)');if(!reduced.matches&&'IntersectionObserver' in window){const reveal=new IntersectionObserver(entries=>entries.forEach(entry=>{if(entry.isIntersecting){entry.target.classList.add('is-revealed');reveal.unobserve(entry.target)}}),{threshold:.12});root.querySelectorAll('[data-reveal],.ed-cards article,.ed-cycle li').forEach(item=>reveal.observe(item))}

  const frame = root.querySelector('[data-elevia-demo]');
  if (!frame) return;
  window.addEventListener('message', event => {
    if (event.origin !== window.location.origin || event.source !== frame.contentWindow) return;
    if (event.data?.type !== 'elevia-demo-height') return;
    const height = Number(event.data.height);
    if (Number.isFinite(height) && height >= 300 && height <= 3000) frame.style.height = Math.ceil(height) + 'px';
  });
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["elevia-app-landing"] && !Shopify.designMode) return;
  try {
    
(function(){
  function init(root){
    if(root.dataset.ready)return;
    root.dataset.ready='true';
    var words=JSON.parse(root.querySelector('[data-elevia-strings]').textContent);Object.keys(words).forEach(function(k){words[k]=new DOMParser().parseFromString(words[k],'text/html').body.textContent;});
    var tabs=Array.from(root.querySelectorAll('[role=tab]'));
    var panels=Array.from(root.querySelectorAll('[role=tabpanel]'));
    function selectTab(tab,focus){
      tabs.forEach(function(item){var active=item===tab;item.setAttribute('aria-selected',String(active));item.setAttribute('tabindex',active?'0':'-1');item.dataset.state=active?'active':'inactive';});
      panels.forEach(function(panel){var active=panel.id===tab.getAttribute('aria-controls');panel.hidden=!active;panel.dataset.state=active?'active':'inactive';});
      if(focus)tab.focus();
    }
    tabs.forEach(function(tab,i){
      tab.addEventListener('click',function(){selectTab(tab,false);});
      tab.addEventListener('keydown',function(e){var index;if(e.key==='ArrowRight')index=(i+1)%tabs.length;else if(e.key==='ArrowLeft')index=(i+tabs.length-1)%tabs.length;else if(e.key==='Home')index=0;else if(e.key==='End')index=tabs.length-1;else return;e.preventDefault();selectTab(tabs[index],true);});
    });
    var menu=root.querySelector('.menu-button'),nav=root.querySelector('nav');
    if(menu&&nav){
      function close(){nav.classList.remove('mobile-open');menu.setAttribute('aria-expanded','false');menu.setAttribute('aria-label',words.menu_open);}
      menu.addEventListener('click',function(){var opened=nav.classList.toggle('mobile-open');menu.setAttribute('aria-expanded',String(opened));menu.setAttribute('aria-label',opened?words.menu_close:words.menu_open);});
      nav.querySelectorAll('a').forEach(function(a){a.addEventListener('click',close);});
      root.addEventListener('keydown',function(e){if(e.key==='Escape')close();});
    }
    root.querySelectorAll('[data-demo-swap]').forEach(function(button){
      button.addEventListener('click',function(){var phone=button.closest('.phone');var swapped=button.dataset.swapped!=='true';button.dataset.swapped=String(swapped);phone.querySelector('.meal-info h4').textContent=swapped?words.swap_title:words.original_title;var icon=button.querySelector('svg').cloneNode(true);button.replaceChildren(icon,document.createTextNode(swapped?words.swap_back:words.swap_action));var p=phone.querySelector('.meal-info p');var clock=p.querySelector('svg').cloneNode(true);var dot=document.createElement('span');dot.textContent='•';p.replaceChildren(clock,document.createTextNode(swapped?'15 Min.':'20 Min.'),dot,document.createTextNode(swapped?words.fresh:words.original_fresh));});
    });
    var days=[words.monday,words.tuesday,words.wednesday,words.thursday,words.friday,words.saturday,words.sunday];
    root.querySelectorAll('[data-demo-day]').forEach(function(button){button.addEventListener('click',function(){var phone=button.closest('.phone');phone.querySelectorAll('[data-demo-day]').forEach(function(b){b.classList.toggle('selected',b===button);b.setAttribute('aria-pressed',String(b===button));});phone.querySelector('.rhythm b').textContent=days[Number(button.dataset.demoDay)]+' '+words.planned;phone.querySelector('.rhythm p').textContent=words.meals_overview;});});
    root.querySelectorAll('.shopping-items input').forEach(function(input){input.addEventListener('change',function(){input.closest('label').classList.toggle('checked',input.checked);var phone=input.closest('.phone');var count=phone.querySelectorAll('.shopping-items input:checked').length;phone.querySelector('.list-intro p').textContent=count+' '+words.count_suffix;});});
    root.querySelectorAll('[data-demo-confirm]').forEach(function(button){button.addEventListener('click',function(){var done=button.dataset.done!=='true';button.dataset.done=String(done);button.textContent=done?'✓ '+words.confirm_done:words.confirm_action+' →';});});
    var success=root.querySelector('.success');
    if(success){success.setAttribute('tabindex','-1');success.focus({preventScroll:true});success.scrollIntoView({behavior:'instant',block:'center'});}
  }
  document.querySelectorAll('[data-elevia-landing]').forEach(init);
  document.addEventListener('shopify:section:load',function(e){e.target.querySelectorAll('[data-elevia-landing]').forEach(init);});
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["elevia-free-plan"] && !Shopify.designMode) return;
  try {
    

document.querySelectorAll('[data-elevia-free-plan]').forEach(root => {
  if (root.dataset.ready) return;
  root.dataset.ready = 'true';
  const menu = root.querySelector('.ed-menu');
  menu.querySelectorAll('a').forEach(link => link.addEventListener('click', () => { menu.open = false; }));
  menu.addEventListener('keydown', event => { if(event.key === 'Escape') { menu.open = false; menu.querySelector('summary').focus(); } });
  document.addEventListener('click', event => { if(menu.open && !menu.contains(event.target)) menu.open = false; });
  const tabs = [...root.querySelectorAll('[role="tab"]')];
  const panels = [...root.querySelectorAll('[role="tabpanel"]')];
  function select(tab, focus) {
    tabs.forEach(item => { const active = item === tab; item.setAttribute('aria-selected', String(active)); item.tabIndex = active ? 0 : -1; });
    panels.forEach(panel => { panel.hidden = panel.id !== tab.getAttribute('aria-controls'); });
    if (focus) tab.focus();
  }
  tabs.forEach((tab, index) => {
    tab.addEventListener('click', () => select(tab, false));
    tab.addEventListener('keydown', event => {
      let target;
      if(event.key === 'ArrowRight') target = (index + 1) % tabs.length;
      else if(event.key === 'ArrowLeft') target = (index + tabs.length - 1) % tabs.length;
      else if(event.key === 'Home') target = 0;
      else if(event.key === 'End') target = tabs.length - 1;
      else return;
      event.preventDefault(); select(tabs[target], true);
    });
  });
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["elevia-partner"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-elevia-partner]').forEach(root => {
const menu=root.querySelector('.ed-menu');
menu.querySelectorAll('a').forEach(link=>link.addEventListener('click',()=>{menu.open=false}));
menu.addEventListener('keydown',event=>{if(event.key==='Escape'){menu.open=false;menu.querySelector('summary').focus()}});
document.addEventListener('click',event=>{if(menu.open&&!menu.contains(event.target))menu.open=false});
const status=root.querySelector('[data-partner-status]');if(status){status.focus();status.scrollIntoView({block:'center'})}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
